<template>
  <tr v-for="item in rows" :key="item">
    <td v-if="expandable" class="placeholder-glow" colspan="1">
      <span class="placeholder w-100"></span>
    </td>
    <td v-if="selectable" class="placeholder-glow" colspan="1">
      <span class="placeholder w-100"></span>
    </td>
    <td v-if="actionable" class="placeholder-glow" colspan="1">
      <span class="placeholder w-100"></span>
    </td>
    <td v-for="col in cols" :key="col" class="placeholder-glow">
      <span class="placeholder w-100"></span>
    </td>
  </tr>
</template>
<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    expandable: boolean;
    selectable: boolean;
    actionable: boolean;
    columns: string[];
    defaultColumns: string[];
    rows?: number; // How many placeholder rows to show
  }>(),
  {rows: 30},
);
// Tables rendered using BE kwargs will need to fetch their column keys
const cols = computed(() => (props.columns.length > 0 ? props.columns : props.defaultColumns));
</script>
